module.exports = __webpack_public_path__ + "static/media/info.9a5993af.svg";